var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$slots.default
        ? _c("span", { on: { click: _vm.set } }, [_vm._t("default")], 2)
        : [
            _c("yxt-button", { on: { click: _vm.set } }, [
              _vm._v(
                _vm._s(_vm.$t("pc_biz_btn_setpointmark" /** 设置关键点标记 */))
              ),
            ]),
            _vm.markNumber
              ? _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("pc_biz_lbl_pointnumber" /** 共标记{0}处 */, [
                        _vm.markNumber,
                      ])
                    )
                  ),
                ])
              : _vm._e(),
          ],
      _c("form-point-drawer", {
        ref: "point",
        attrs: { "kng-id": _vm.kngId, "file-id": _vm.fileId },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }